import { useTranslation } from 'react-i18next';
import { Link, Links, Meta, Scripts } from 'react-router';

import useRegion from '~/hooks/useRegion';
import Footer from '~/legacy/components/footer';

import { DynamicHeader } from './DynamicHeader';

export default function Error404() {
  const region = useRegion();
  const { t } = useTranslation('error');

  return (
    <html lang={region.lang}>
      <head>
        <title>{t('pageNotFound')}</title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        <DynamicHeader region={region} />
        <main>
          <div className="box-border">
            <div className="min-h-[33vh] bg-[url('https://cms-cdn.thesolesupplier.co.uk/bolt/404.jpg')] bg-cover bg-center md:min-h-[66vh]">
              <div className="inset-x-0 flex flex-col py-10 text-center text-white drop-shadow-[2px_2px_rgb(0,0,0)]">
                <h1 className="my-8 text-2xl font-bold md:py-7 md:text-5xl">
                  404
                </h1>
                <p className="text-base md:text-4xl">
                  {t('thePageYouWereLookingForDoesNotSeemToExist')}
                </p>
                <div className="m-1.5 text-sm md:text-sm">
                  <Link to="/">
                    <button className="my-11 cursor-pointer rounded-2xl border border-white px-3 py-1">
                      {t('backToHome')}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </main>
      </body>
      <Scripts />
    </html>
  );
}
